"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialog = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const Dialog_1 = __importDefault(require("../Dialog"));
const DialogSize_1 = __importDefault(require("../Dialog/DialogSize"));
const makeMyClasses = color => ({
    content: {
        padding: 4,
        borderTop: '4px solid ' + color.main,
    },
});
function ConfirmDialog(props) {
    const { color = lib_palette_1.default.Grey, size = DialogSize_1.default.X400_Y250, onClose, agreeText = lib_i18n_1.default.t('yes'), notAgreeText = lib_i18n_1.default.t('no'), canConfirm = true, disableGoBackOnConfirm = false, onConfirm, confirmationText, children, } = props;
    const [busy, setBusy] = (0, react_1.useState)(false);
    const [confText, setConfText] = (0, react_1.useState)('');
    const { goBack } = (0, useNav_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses, [color]);
    const isConfirmDisabled = !canConfirm || busy || (!!confirmationText && confText !== confirmationText);
    const handleClose = (0, react_1.useCallback)(() => {
        setBusy(false);
        return onClose ? onClose() : goBack();
    }, [goBack, onClose]);
    const handleConfirmClick = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        setBusy(true);
        onConfirm &&
            (yield onConfirm()
                .then(() => !disableGoBackOnConfirm && handleClose())
                .catch(() => setBusy(false)));
    }), [disableGoBackOnConfirm, handleClose, onConfirm]);
    return (react_1.default.createElement(Dialog_1.default, Object.assign({ white: true, size: size, closable: false, classes: { content: myCss.content } }, props, { buttonsLeft: react_1.default.createElement(Button_1.default, { onClick: handleClose, color: lib_palette_1.default.Grey, disabled: busy, tabIndex: 1, label: notAgreeText }), buttonsRight: react_1.default.createElement(Button_1.default, { onClick: handleConfirmClick, color: props.color || lib_palette_1.default.Grey, disabled: isConfirmDisabled, tabIndex: 0, label: agreeText }) }),
        children,
        !!confirmationText && (react_1.default.createElement(Vertical_1.default, { style: { marginTop: 8 } },
            react_1.default.createElement(Text_1.default, null,
                "Enter \"",
                confirmationText,
                "\" into the box below to confirm."),
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { value: confText, onChange: setConfText, fullWidth: true, placeholder: confirmationText })))));
}
exports.ConfirmDialog = ConfirmDialog;
exports.default = ConfirmDialog;
